// extracted by mini-css-extract-plugin
export var legends = "Gallery-module--legends--WwcbL";
export var colorBox = "Gallery-module--color-box--2dcvJ";